export default "__VITE_ASSET__7a04680e__"